import {BOOKABLE_TEMPLATES, isRenderedTemplate, type RenderedTemplateKey} from "sponsor/sponsorBooking";

/**
 * What `/advertising` offers, and therefore what it COUNTS (kitecorp/transferify-ui#1870). Plain
 * TypeScript — this module imports no React — so the page's one number is derived in a tested place
 * rather than written into a sentence.
 *
 * The page states this figure three times: the gallery's heading, the terms strip's treatment cell, and
 * the hero's demo caption. All three read this list, so they cannot disagree with each other or with
 * the cards under them. Every one of them was a written-out word before this ticket, and the count has
 * been wrong twice — the prose said "three" through two widenings before ui#624 added the coverflow,
 * and "six" from the day the wallpapers shipped.
 *
 * ## Two conditions, not one
 *
 * A card here is a LIVE PREVIEW that links to the booking form, so a treatment earns one only when both
 * halves hold:
 *
 *  - it can be BOOKED (`BOOKABLE_TEMPLATES`, the option table's own membership) — otherwise the card
 *    sends a reader to a form that does not offer it;
 *  - it can be DRAWN (`isRenderedTemplate`) — otherwise the card is an empty box on a page whose whole
 *    claim is that every preview is the real renderer.
 *
 * The two are the same set today and are normally the same set. They part company exactly when a
 * treatment is in the api's contract but half-shipped here, which is the state the catalogue was left in
 * when kitecorp/transferify-ui#1867 was reverted off master — and on that day listing either one alone
 * would have put a card on a public page that previews nothing or books nothing. Asking both questions
 * is also what narrows the element type to something the renderer accepts, so a treatment with no effect
 * cannot reach a mount even by mistake.
 */
export const ADVERTISED_TREATMENTS: readonly RenderedTemplateKey[] =
	BOOKABLE_TEMPLATES.filter(isRenderedTemplate);
